<template>
  <Dropdown @on-click="handleClick">
    <div class="language-box">
      <span class="language-icon">
        <svg viewBox="0 100 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
        width="100%" height="100%">
          <path d="M917.1 109.5H218.6v106.6H106.1v698.5h698.5V808h112.5V109.5zM744.6 854.6H166.1V276.1h578.5v578.5zM857.1 748h-52.5V216.1h-526v-46.6h578.5V748z"
             ></path>
          <path d="M401.5 640.4h103.1l32.8 124.2h56.3L476.5 359.1h-46.9L312.4 764.6h56.3l32.8-124.2z m49.2-187.5h4.7l37.5 143h-79.7l37.5-143z"
            ></path>
        </svg>
      </span>
      <span>{{ curLng }}</span>
    </div>
    <Dropdown-menu slot="list">
      <Dropdown-item 
        v-for="item in lanArr" 
        :key="item.value" 
        :name="item.value" 
        :disabled="item.value === langage"
        >
        {{ item.label[langage] }}
      </Dropdown-item>
    </Dropdown-menu>
  </Dropdown>
</template>
<script>
import { lanArr } from '@/utils/language';
import { mapState } from 'vuex';

export default {
  name: 'Language-box',
  data() {
    return {
      lanArr: lanArr,
    }
  },
  computed: {
    ...mapState({
      langage: state => state.app.language,
      curLng: state => { 
        const _lan = state.app.language;
        const curItem = lanArr.find(item => item.value === _lan);
      
        return curItem ? curItem.name[_lan] : '';
      }
    }),
  },
  methods: {
    handleClick(name) {
      const route = this.$route;
      console.info('_route>>', route);
      this.$store.commit('setLanguage', {language:name,route});
    }
  }
}
</script>
<style lang="less" scoped>
.language-box{
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: 14px;
  padding-right: 6px;
  color: #515151;
  fill: #515151;
  &:hover{
    color: #2d8cf0;
    fill: #2d8cf0;
  }
}
.language-icon{
  display: inline-block;
  width: 26px;
  height: 26px;
  margin: -15px 3px 0 0;
}
</style>